import { useState } from 'react';

import endpoints from '../../../../../../../api/endpoints';
import { useDialog } from '../../../../../../common/dialog/useDialog';
import { useHandleApiError } from '../../../../../../../api/useHandleApiError';
import { handleResponseError } from '../../../../../../../api/handleResponseError';
import { fetchWithTokenRefresh } from '../../../../../../../api/fetchWithTokenRefresh';

import { Operation } from '../operation-metadata/interfaces';
import { operationDetailsBusinessError } from '../businessErrors';

export const useShowOperationDetails = () => {
  const [selectedOperationDetails, setSelectedOperationDetails] = useState<Operation | undefined>();
  const [waitingForDialogOpening, setWaitingForDialogOpening] = useState<boolean>(false);
  const { isDialogOpen, handleOpenDialog, handleCloseDialog } = useDialog();

  const handleApiBusinessError = useHandleApiError();
  const handleOpenDetailsDialog = async (sessionId: string) => {
    try {
      setWaitingForDialogOpening(true);
      const response = await fetchWithTokenRefresh(endpoints.wapOperations(sessionId));
      if (response.status !== 200) {
        await handleResponseError(response);
      }
      const operation = await response.json();
      setWaitingForDialogOpening(false);
      setSelectedOperationDetails(operation);
      handleOpenDialog();
    } catch (e) {
      setWaitingForDialogOpening(false);

      handleApiBusinessError({
        message: e,
        errorMapper: operationDetailsBusinessError
      });
    }
  };

  const handleCloseDetailsDialog = () => {
    handleCloseDialog();
  };

  return {
    selectedOperationDetails,
    openDetailsDialog: isDialogOpen,
    waitingForDialogOpening,
    handleOpenDetailsDialog,
    handleCloseDetailsDialog
  };
};
